"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformOwnerParsedResponse = void 0;
function transformOwnerParsedResponse(owner) {
    return {
        userId: owner.userid,
        email: owner.email,
        fName: owner.fname,
        lName: owner.lname,
        organization: owner.organization,
    };
}
exports.transformOwnerParsedResponse = transformOwnerParsedResponse;
//# sourceMappingURL=Owner.js.map